module.exports = __webpack_public_path__ + "fonts/fa-duotone-900.ba609db.woff2";